<!-- @Description AI4Science-AI+新药研发产品矩阵 -->
<template>
  <van-collapse v-model="activeName" accordion class="productmatrix">
    <van-collapse-item
      title="新药研发基本流程"
      name="1"
      class="productmatrix-item"
      :class="{ 'productmatrix-item-check': activeName == '1' }"
    >
      <div class="info">传统新药研发流程与我们华院基于AI的药物筛选平台研发管线。
        <br />
        上半部分描述了从靶点发现、先导化合物筛选、临床前研究到ND申报及临床试验直至上市的完整周期流程;下半部分则以AI驱动的筛选平台为核心，针对小分子与多肽等不同分子类型，在靶点发现、药物筛选、药效与药代评价等关键环节实现流程前移与加速优化，并面向抗衰老、神经退行性疾病及干细胞分化等具体应用场景构建高效研发管线，体现了AI在缩短研发周期与提升筛选效率方面的核心价值。</div>
      <img
        :src="productImg1"
        alt="新药研发基本流程"
        class="productmatrix-img"
      />
      <div class="superiority" v-if="advantageList.xylcyjblc.length">
        <div class="title">产品价值</div>
        <div
          class="superiority-item"
          v-for="(item, index) in advantageList.xylcyjblc"
          :key="`productmatrix-item1-superiority${index + 1}`"
        >
          <img :src="product_society_superiority" alt="重要性标志" />
          <span>{{ item }}</span>
        </div>
      </div>
    </van-collapse-item>
    <van-collapse-item
      title="基于AI的药物筛选平台"
      name="2"
      class="productmatrix-item"
      :class="{ 'productmatrix-item-check': activeName == '2' }"
    >
      <div class="info">基于AI的药物筛选平台，分为数据层、引擎层和应用层。比如对一个我们明确的药物靶点，基于华院计算认知智能引擎平台，生物、化学等高质量数据作为数据燃料，筛选出候选药物，并通过医学实验验证，获得多种针对这一靶点的多肽类药物、小分子药物、抗体药物等。</div>
      <img
        v-if="productImg2"
        :src="productImg2"
        alt="基于AI的药物筛选平台"
        class="productmatrix-img"
      />
      <div class="superiority" v-if="advantageList.ywsxpt.length">
        <div class="title">产品价值</div>
        <div
          class="superiority-item"
          v-for="(item, index) in advantageList.ywsxpt"
          :key="`productmatrix-item2-superiority${index + 1}`"
        >
          <img :src="product_society_superiority" alt="重要性标志" />
          <span>{{ item }}</span>
        </div>
      </div>
    </van-collapse-item>
  </van-collapse>
</template>
<script>
import product_society_superiority from "@/../static/img/product/product_society_superiority.png";
import aixy1 from "@/../static/img/product/aixy1.png";
import aixy2 from "@/../static/img/product/aixy2.png";

export default {
  data() {
    return {
      product_society_superiority,
      productImg1: aixy1,
      productImg2: aixy2,
      activeName: "",
      advantageList: {
        xylcyjblc: [],
        ywsxpt: []
      }
    };
  }
};
</script>
<style lang="less" scoped>
.productmatrix {
  width: 100%;
  /deep/.van-cell {
    height: 94px;
    font-size: 28px;
    color: #08204d;
    line-height: 94px;
    text-align: center;
  }
  /deep/ .van-cell__right-icon {
    display: none;
  }
  .productmatrix-item {
    padding: 0 64px;
    background: #ffffff;
    .info {
      font-size: 24px;
      font-family: PingFang-SC-Regular, PingFang-SC;
      font-weight: 400;
      color: #08204d;
      line-height: 40px;
      text-align: justify;
    }
  }
  .productmatrix-item-check {
    /deep/.van-cell__title::before {
      content: "";
      position: absolute;
      bottom: 0px;
      left: 35%;
      width: 30%;
      height: 2px;
      background-color: blue;
    }
  }
  .productmatrix-img {
    width: 100%;
    margin: 44px 0;
  }
  .superiority {
    margin-bottom: 32px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    .title {
      width: 100%;
      height: 36px;
      font-size: 26px;
      color: #08204d;
      line-height: 36px;
      margin-bottom: 24px;
      font-weight: 600;
    }
    .superiority-item {
      display: flex;
      font-size: 24px;
      color: #08204d;
      line-height: 32px;
      margin: 0 50px 32px 0;
      > img {
        width: 32px;
        height: 32px;
        margin-right: 16px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/product/digitization/productmatrix.vue